import CustomModal from '@/legacy-ported/components/base/CustomModal'
import GeneratingOverlayWordPdf from '@/legacy-ported/components/document/overlay/GeneratingOverlayWordPdf'
import { downloadDocs } from '@/utils/downloadDocs'
import { Button } from 'nsw-ds-react'
import { useRef, useState } from 'react'
import Icon from '../Icon'

export const DownloadSyllabusOrCourseButton = ({
	syllabusCodename,
	isPreviewMode,
}: {
	syllabusCodename: string
	isPreviewMode: boolean
}) => {
	const refAbortController = useRef<AbortController>(new AbortController())
	const [generatingStatus, setGeneratingStatus] = useState(false)
	const [errorPopupMessage, setErrorPopupMessage] = useState('')

	const handleDownload = async () => {
		setGeneratingStatus(true)
		const [_, errorMessage] = await downloadDocs(
			{
				stages: [],
				syllabuses: [syllabusCodename],
				tabs: [],
				pdf: true,
				tags: [],
				isPreviewMode: isPreviewMode || false,
				languages: [],
			},
			refAbortController.current.signal,
		)

		if (refAbortController.current?.signal?.aborted) return
		if (errorMessage) {
			setErrorPopupMessage(errorMessage)
		}
		setGeneratingStatus(false)
	}

	const handleCancelGeneratingWordPdf = () => {
		refAbortController.current.abort()
		refAbortController.current = null
		setGeneratingStatus(false)
	}

	return (
		<>
			<Button
				className="flex justify-center"
				style="white"
				css={{
					'& > *': {
						flexShrink: 0,
					},
				}}
				onClick={handleDownload}
			>
				<span className="mr-2">Download syllabus/course</span>
				<Icon icon="bxs:download" />
			</Button>
			<GeneratingOverlayWordPdf
				modalStatus={generatingStatus}
				handleCancel={handleCancelGeneratingWordPdf}
			/>
			{errorPopupMessage && (
				<CustomModal
					title="Error"
					modalStatus={!!errorPopupMessage}
					handleCancel={() => setErrorPopupMessage('')}
					hideConfirmButton
				>
					<p>{errorPopupMessage}</p>
				</CustomModal>
			)}
		</>
	)
}
